﻿import config from "../config"
const baseUrl = config.base_url + "container_space_time/"
export default {
    page: {
        url:  baseUrl + "page/{limit}/{page}",
        type: "get",
    },
    remove: {
        url:  baseUrl + "delete",
        type: "get",
    },
    save: {
        url:  baseUrl + "save",
        type: "post",
    },
    detail: {
        url:  baseUrl + "getDetail",
        type: "get",
    },
    solarTermsList: {
        url:  baseUrl + "solarTermsList",
        type: "get",
    },
    // 获取大区下拉数据
    getRegionList: {
        url:  baseUrl + "getRegionList",
        type: "get",
    },
    getProvinceList: {
        url:  baseUrl + "getProvinceList",
        type: "get",
    },
    getCountyList: {
        url:  baseUrl + "getCountyList",
        type: "get",
    },
    getCityList:{
        url:  baseUrl + "getCityList",
        type: "get",
    },
    getDetail: {
        url: baseUrl + "getDetail",
        type: "get",
    },
    getRegionList: {
        url: baseUrl + "getRegionList",
        type: "get",
    },
    changeRegion: {
        url: baseUrl + "changeRegion",
        type: "post",
    },
} 
